import { render, staticRenderFns } from "./credit-management.vue?vue&type=template&id=124762bc&scoped=true&"
import script from "./credit-management.vue?vue&type=script&lang=js&"
export * from "./credit-management.vue?vue&type=script&lang=js&"
import style0 from "./credit-management.vue?vue&type=style&index=0&id=124762bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124762bc",
  null
  
)

export default component.exports